var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-not-filled"},[_c('img',{staticClass:"img-fluid data-not-filled__img",attrs:{"src":require("@/assets/img/icon-close-not-data.png"),"alt":"icon close","title":"icon close"}}),_c('p',{staticClass:"data-not-filled__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }